import { render } from "./Backdrop.vue?vue&type=template&id=b7315290&scoped=true"
import script from "./Backdrop.vue?vue&type=script&lang=js"
export * from "./Backdrop.vue?vue&type=script&lang=js"

import "./Backdrop.vue?vue&type=style&index=0&id=b7315290&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7315290"]])

export default __exports__